export default {
  components: {},
  props: {
    items: Array,
    cardListName: String
  }
};